import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-center gap-4" }
const _hoisted_2 = { class: "flex flex-col place-items-center overflow-hidden" }
const _hoisted_3 = ["src"]

import BaseCard from '@/features/global/BaseCard.vue';
import JugClass from '@/assets/Projects/ClimbingHoldClassifierPhotos/JugClass.jpg';
import { useImageViewer } from '@/features/composables/useImageViewer';


export default /*@__PURE__*/_defineComponent({
  __name: 'ClimbingHoldClassifierSpec',
  setup(__props) {

const { openImageMenu } = useImageViewer();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseCard, {
    title: 'Climbing Hold Classifier',
    highlightLastWord: false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "w-full grid lg:grid-cols-2 lg:gap-20" }, [
          _createElementVNode("h5", { class: "lg:justify-self-end lg:pr-6 font-medium" }, "Solo Engineer"),
          _createElementVNode("h5", { class: "lg:justify-self-start lg:pl-6 font-medium" }, "January 2026 - Present")
        ], -1)),
        _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-center items-center px-4 gap-2" }, [
          _createElementVNode("span", { class: "block" }, " As part of my Computer Vision class, I designed a 5-stage Computer Vision pipeline for classifying climbing holds in images into 7 classes. This whole project started from a climbing joke as none of us can tell the difference between a jug and a sloper (look it up, it's painful), so I wanted to see if AI could do any better. "),
          _createElementVNode("span", { class: "block" }, " The pipeline begins with a trained YOLO11n object detection model to detect climbing holds, followed by cropping and CLAHE normalization to enhance contrast. Next, a SAM segmentation model segments the climbing hold from the background, which is then passed into a trained ResNet-18 CNN to extract features. Finally, the extracted features are passed into a RBF-kernel SVM to classify the climbing hold. "),
          _createElementVNode("span", { class: "block" }, " Since I could not find a dataset of climbing hold images that meet the image requirements that I designed, I collected and labeled 2000 climbing hold images from Notre Dame's climbing wall, taken from my phone at 5 different angles for each hold. I then split the dataset into a 70/15/15 train/validation/test split, then trained and validated 8 different pipeline architectures. "),
          _createElementVNode("span", { class: "block" }, " After finding the best performing architecture, the final pipeline achieved 80.2% test accuracy. "),
          _createElementVNode("a", {
            href: "https://github.com/cgreen2048/Climbing-Hold-Classifier",
            target: "_blank"
          }, [
            _createTextVNode(" View my "),
            _createElementVNode("span", { class: "link-in-text" }, " Github Repo ")
          ])
        ], -1)),
        _createElementVNode("span", _hoisted_2, [
          _createElementVNode("img", {
            class: "w-[50%] h-auto rounded-lg cursor-pointer",
            src: _unref(JugClass),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(openImageMenu)(_unref(JugClass), 'Jug Class Screenshot', $event.currentTarget)))
          }, null, 8, _hoisted_3)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})